module.exports = __webpack_public_path__ + "media/images/athletes/1760-e03439930c349fa77ed958c7874d801d.png";